import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, vModelSelect as _vModelSelect, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "d-flex justify-between" }
const _hoisted_3 = { class: "form-group" }
const _hoisted_4 = {
  key: 0,
  class: "error-message"
}
const _hoisted_5 = { class: "checkbox-group" }
const _hoisted_6 = { class: "checkbox-group" }
const _hoisted_7 = {
  key: 0,
  class: "form-group"
}
const _hoisted_8 = {
  key: 1,
  class: "form-group"
}
const _hoisted_9 = { class: "btn-group" }
const _hoisted_10 = ["disabled"]
const _hoisted_11 = {
  key: 0,
  class: "modal-backdrop"
}
const _hoisted_12 = { class: "modal" }
const _hoisted_13 = { class: "modal-footer" }
const _hoisted_14 = {
  key: 1,
  class: "modal-backdrop"
}
const _hoisted_15 = {
  key: 2,
  class: "modal-backdrop"
}
const _hoisted_16 = {
  key: 3,
  class: "modal-backdrop"
}
const _hoisted_17 = { class: "modal" }
const _hoisted_18 = { class: "modal-body" }
const _hoisted_19 = { class: "modal-footer" }

import { ref } from 'vue'
import api from '../../../api/v2/api'


export default /*@__PURE__*/_defineComponent({
  __name: 'MyProfileUserAccountDeletion',
  setup(__props) {

const password = ref('')
const confirmDelete = ref(false)
const confirmReason = ref(false)
const reason = ref('')
const otherReason = ref('')
const showConfirmModal = ref(false)
const processing = ref(false)
const showSuccessModal = ref(false)
const showErrorModal = ref(false)
const errorMessage = ref('')
const passwordError = ref('')

const showConfirmation = () => {
  if (password.value.length < 4) {
    passwordError.value = 'パスワードが正しくありません'
    return
  }
  passwordError.value = ''
  showConfirmModal.value = true
}

const deleteAccount = () => {
  processing.value = true
  showConfirmModal.value = false
  api.user.destroy(password.value, reason.value, otherReason.value).then(() => {
    processing.value = false
    showSuccessModal.value = true
  }).catch((error) => {
    processing.value = false
    showErrorModal.value = true
    errorMessage.value = error.messages
    console.error(error)
  })
}

const goBack = () => {
  window.history.back()
}

const redirectToHome = () => {
  window.location.href = '/'
}

const redirectToMyProfile = () => {
  window.location.href = '/classroom/myprofile?section=deletion'
}

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_v_btn, {
        variant: "outlined",
        size: "small",
        onClick: goBack
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_icon, null, {
            default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
              _createTextVNode("mdi-arrow-left", -1 /* CACHED */)
            ]))]),
            _: 1 /* STABLE */
          })
        ]),
        _: 1 /* STABLE */
      })
    ]),
    _cache[21] || (_cache[21] = _createElementVNode("h1", { class: "mt-2" }, "アカウント退会", -1 /* CACHED */)),
    _cache[22] || (_cache[22] = _createElementVNode("div", { class: "alert-warning" }, [
      _createElementVNode("p", null, [
        _createElementVNode("i", { class: "fas fa-exclamation-triangle icon-warning" }),
        _createTextVNode(" 退会すると、以下のデータが完全に削除され、復元できなくなります： ")
      ]),
      _createElementVNode("ul", null, [
        _createElementVNode("li", null, "学習履歴やテスト結果"),
        _createElementVNode("li", null, "購入したコースへのアクセス権"),
        _createElementVNode("li", null, "保存された学習進捗状況")
      ])
    ], -1 /* CACHED */)),
    _createElementVNode("form", {
      onSubmit: _withModifiers(showConfirmation, ["prevent"])
    }, [
      _createElementVNode("div", _hoisted_3, [
        _cache[8] || (_cache[8] = _createElementVNode("label", { for: "password" }, "現在のパスワード", -1 /* CACHED */)),
        _withDirectives(_createElementVNode("input", {
          type: "password",
          id: "password",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((password).value = $event)),
          required: "",
          placeholder: "退会確認のため、現在のパスワードを入力してください"
        }, null, 512 /* NEED_PATCH */), [
          [_vModelText, password.value]
        ]),
        (passwordError.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(passwordError.value), 1 /* TEXT */))
          : _createCommentVNode("v-if", true)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("label", null, [
          _withDirectives(_createElementVNode("input", {
            type: "checkbox",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((confirmDelete).value = $event)),
            required: ""
          }, null, 512 /* NEED_PATCH */), [
            [_vModelCheckbox, confirmDelete.value]
          ]),
          _cache[9] || (_cache[9] = _createTextVNode(" 退会するとすべてのデータが削除され、復元できないことを理解しました ", -1 /* CACHED */))
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("label", null, [
          _withDirectives(_createElementVNode("input", {
            type: "checkbox",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((confirmReason).value = $event))
          }, null, 512 /* NEED_PATCH */), [
            [_vModelCheckbox, confirmReason.value]
          ]),
          _cache[10] || (_cache[10] = _createTextVNode(" 退会理由を教えていただけると、サービス改善の参考にさせていただきます（任意） ", -1 /* CACHED */))
        ])
      ]),
      (confirmReason.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _cache[12] || (_cache[12] = _createElementVNode("label", { for: "reason" }, "退会理由", -1 /* CACHED */)),
            _withDirectives(_createElementVNode("select", {
              id: "reason",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((reason).value = $event))
            }, [...(_cache[11] || (_cache[11] = [
              _createStaticVNode("<option value=\"\" data-v-5a5b7adc>選択してください</option><option value=\"1\" data-v-5a5b7adc>使用頻度が少ない</option><option value=\"2\" data-v-5a5b7adc>他のサービスに乗り換える</option><option value=\"3\" data-v-5a5b7adc>期待していた内容と違った</option><option value=\"4\" data-v-5a5b7adc>料金が高い</option><option value=\"5\" data-v-5a5b7adc>使いにくい</option><option value=\"6\" data-v-5a5b7adc>その他</option>", 7)
            ]))], 512 /* NEED_PATCH */), [
              [_vModelSelect, reason.value]
            ])
          ]))
        : _createCommentVNode("v-if", true),
      (reason.value === '6')
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _cache[13] || (_cache[13] = _createElementVNode("label", { for: "otherReason" }, "その他の理由", -1 /* CACHED */)),
            _withDirectives(_createElementVNode("textarea", {
              id: "otherReason",
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((otherReason).value = $event)),
              placeholder: "退会理由を詳しく教えてください"
            }, null, 512 /* NEED_PATCH */), [
              [_vModelText, otherReason.value]
            ])
          ]))
        : _createCommentVNode("v-if", true),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-secondary text-white",
          onClick: redirectToMyProfile
        }, "キャンセル"),
        _createElementVNode("button", {
          type: "submit",
          class: "btn btn-danger",
          disabled: !confirmDelete.value
        }, "退会手続きへ進む", 8 /* PROPS */, _hoisted_10)
      ])
    ], 32 /* NEED_HYDRATION */),
    _createCommentVNode(" 確認モーダル "),
    (showConfirmModal.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _cache[14] || (_cache[14] = _createElementVNode("div", { class: "modal-header" }, [
              _createElementVNode("h2", null, [
                _createElementVNode("i", { class: "fas fa-exclamation-triangle icon-warning" }),
                _createTextVNode(" 最終確認")
              ])
            ], -1 /* CACHED */)),
            _cache[15] || (_cache[15] = _createElementVNode("div", { class: "modal-body" }, [
              _createElementVNode("p", null, "本当にアカウントを削除しますか？この操作は取り消せません。"),
              _createElementVNode("p", null, [
                _createElementVNode("strong", null, "すべての学習データ、テスト結果、およびコース進捗状況が完全に削除されます。")
              ])
            ], -1 /* CACHED */)),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("button", {
                class: "btn btn-secondary text-white",
                onClick: _cache[5] || (_cache[5] = ($event: any) => (showConfirmModal.value = false))
              }, "キャンセル"),
              _createElementVNode("button", {
                class: "btn btn-danger",
                onClick: deleteAccount
              }, "削除する")
            ])
          ])
        ]))
      : _createCommentVNode("v-if", true),
    _createCommentVNode(" 処理中オーバーレイ "),
    (processing.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [...(_cache[16] || (_cache[16] = [
          _createElementVNode("div", { class: "processing-overlay" }, [
            _createElementVNode("div", { class: "spinner" }),
            _createElementVNode("p", null, "処理中です。しばらくお待ちください...")
          ], -1 /* CACHED */)
        ]))]))
      : _createCommentVNode("v-if", true),
    _createCommentVNode(" 完了モーダル "),
    (showSuccessModal.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
          _createElementVNode("div", { class: "modal" }, [
            _cache[17] || (_cache[17] = _createElementVNode("div", { class: "modal-header" }, [
              _createElementVNode("h2", { style: {"color":"#2ecc71"} }, [
                _createElementVNode("i", { class: "fas fa-check-circle" }),
                _createTextVNode(" 退会手続き完了")
              ])
            ], -1 /* CACHED */)),
            _cache[18] || (_cache[18] = _createElementVNode("div", { class: "modal-body" }, [
              _createElementVNode("p", null, "アカウント削除が完了しました。ご利用いただきありがとうございました。"),
              _createElementVNode("p", null, "またのご利用をお待ちしております。")
            ], -1 /* CACHED */)),
            _createElementVNode("div", { class: "modal-footer" }, [
              _createElementVNode("button", {
                class: "btn btn-secondary text-white",
                onClick: redirectToHome
              }, "トップページへ")
            ])
          ])
        ]))
      : _createCommentVNode("v-if", true),
    _createCommentVNode(" エラーモーダル "),
    (showErrorModal.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            _cache[20] || (_cache[20] = _createElementVNode("div", { class: "modal-header" }, [
              _createElementVNode("h2", null, [
                _createElementVNode("i", { class: "fas fa-exclamation-circle icon-warning" }),
                _createTextVNode(" エラー")
              ])
            ], -1 /* CACHED */)),
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("p", null, _toDisplayString(errorMessage.value), 1 /* TEXT */),
              _cache[19] || (_cache[19] = _createElementVNode("p", null, "問題が解決しない場合は、サポートまでお問い合わせください。", -1 /* CACHED */))
            ]),
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("button", {
                class: "btn btn-secondary text-white",
                onClick: _cache[6] || (_cache[6] = ($event: any) => (showErrorModal.value = false))
              }, "閉じる")
            ])
          ])
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}
}

})